/* eslint-disable import/first */
import React from "react";

import {
  ShoppingCart,
  Sliders,
  Settings as SettingsIcon,
  Users,
  List,
  EyeOff,
} from "react-feather";
import RouterIcon from "@material-ui/icons/Router";
import StorefrontIcon from "@material-ui/icons/Storefront";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
// Auth components
import SignIn from "../pages/auth/SignIn";
import ResetPassword from "../pages/auth/ResetPassword";
import Page404 from "../pages/auth/Page404";
import Page500 from "../pages/auth/Page500";

// Components components
import Default from "../pages/dashboards/Default/index";
import EmailConfirmation from "../components/EmailConfirmation";
import ChangePassword from "../components/ChangePassword";
import Payments from "../pages/pages/Payments";
import Settings from "../pages/pages/Settings";
import StorePage from "../pages/pages/Store";
import CouponsPage from "../pages/pages/Coupons";
import InvoiceDetails from "../pages/pages/InvoiceDetails";
import ApRestrictionsCategory from "../pages/AP/apRestrictionsCategory";
import ApMaintenance from "../pages/AP/apMaintenance";

const dashboardsRoutes = {
  id: "Dashboard",
  translationKey: "navigation.dashboard",
  path: "/dashboard",
  icon: <Sliders />,
  component: Default,
};

const invoiceRoutes = {
  id: "Pagos",
  translationKey: "navigation.payments",
  path: "/payments",
  icon: <ShoppingCart />,
  component: Payments,
  children: null,
};

const invoiceDetailsRoute = {
  id: "Invoice detail",
  path: "/invoiceDetail",
  icon: <Sliders />,
  component: InvoiceDetails,
};

const configurationRoutes = {
  id: "Configuraciones",
  translationKey: "navigation.settings",
  path: "/settings",
  icon: <SettingsIcon />,
  component: Settings,
  children: null,
};

const storeRoutes = {
  id: "Tienda",
  translationKey: "navigation.store",
  path: "/store",
  icon: <StorefrontIcon />,
  component: StorePage,
  children: null,
};

const couponsRoutes = {
  id: "Cupones",
  translationKey: "navigation.coupons",
  path: "/coupons",
  icon: <ConfirmationNumberIcon />,
  component: CouponsPage,
  children: null,
};

const apConfigRoutes = {
  id: "Access Point",
  translationKey: "navigation.accessPoints",
  path: "/ap-restrictions",
  icon: <RouterIcon />,
  component: ApRestrictionsCategory,
  children: [
    {
      path: "/ap-restrictions",
      name: "Restricciones",
      translationKey: "navigation.restrictions",
      component: ApRestrictionsCategory,
      icon: <EyeOff />,
    },
    {
      path: "/ap-maintenance",
      name: "AP Mantenimiento",
      translationKey: "navigation.maintenance",
      component: ApMaintenance,
      icon: <List />,
    },
  ],
};

// Routes using the Dashboard layout
export const dashboardLayoutRoutes = [
  dashboardsRoutes,
  invoiceRoutes,
  invoiceDetailsRoute,
  apConfigRoutes,
  configurationRoutes,
  storeRoutes,
  couponsRoutes,
];

const authRoutes = {
  id: "Auth",
  path: "/auth",
  icon: <Users />,
  children: [
    {
      path: "/auth/sign-in",
      name: "Sign In",
      component: SignIn,
    },
    {
      path: "/auth/reset-password",
      name: "Reset Password",
      component: ResetPassword,
    },
    {
      path: "/auth/404",
      name: "404 Page",
      component: Page404,
    },
    {
      path: "/auth/500",
      name: "500 Page",
      component: Page500,
    },
    {
      path: "/emailConfirmation/:id",
      name: "Email confirmation",
      component: EmailConfirmation,
    },
    {
      path: "/forgotPasswordLast/:id",
      name: "Change Password",
      component: ChangePassword,
    },
  ],
  component: null,
};

// Routes using the Auth layout
export const authLayoutRoutes = [authRoutes];

// Routes visible in the sidebar
export const sidebarRoutes = [
  dashboardsRoutes,
  invoiceRoutes,
  apConfigRoutes,
  configurationRoutes,
  storeRoutes,
  couponsRoutes,
];
